import Preloader from '@/common/components/Preloader/Preloader';

export default Preloader;
